<template>
 
       <fragment v-if="data.drug_suscept">             
                               
                                <td >{{ done }}</td>
                                <td >{{ data.drug_suscept.date }}</td>
                                <td  >{{ result }}</td>
                               
                                
                              
        </fragment>                     
        <fragment v-else>             
                               
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                               
                                
                              
        </fragment>                     
                    
                  
</template>

<script>



export default {
  name: 'Body',
  props:["data"],
  data () {
    return {
    }
  },

  computed: 
  {
     done()
     {
         if (this.data.drug_suscept.done==1)
         {
             return "Done";
         }
         else 
         {
             return "Not Done";
         }
     },
     result()
     {
         var result=null;
          var value=parseInt(this.data.drug_suscept.result);
          
         switch (value)
         {
             case 1: result="H resistant";break;
             case 2: result="R resistant";break;
             case 3: result="Z resistant";break;
             case 4: result="L resistant";break;
             case 5: result="S resistant";break;
             case 6: result="Multi Drug resistant";break;
             case 7: result="Poly Drug resistant";break;
             case 8: result="Missing";break;
         }

         return result;
     }
  }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    
     
</style>
